// Accessibility helpers shared by charts (owned by the web:charts agent).

import type { CSSProperties } from 'react';

/**
 * Visually-hidden style: keeps content in the accessibility tree and available
 * to screen readers while removing it from the visual layout. Used to attach a
 * data table fallback to canvas figures.
 */
export const srOnly: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
};
